import actionTypes from 'Redux/constants';

const initialState = {
  // Mirrors the GET /product-library/ response shape
  product: null, // { uuid, name, is_default }
  isEmpty: true,
  categories: [], // [{ uuid, name, flows: [...] }]
  isLoading: true,
  isSaving: false,
  error: null,
};

const productLibraryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.productLibrary.setLibrary:
      return {
        ...state,
        product: action.payload.product ?? null,
        isEmpty: action.payload.is_empty ?? true,
        categories: action.payload.categories ?? [],
      };

    case actionTypes.productLibrary.setIsLoading:
      return { ...state, isLoading: action.payload };

    case actionTypes.productLibrary.setIsSaving:
      return { ...state, isSaving: action.payload };

    case actionTypes.productLibrary.setError:
      return { ...state, error: action.payload };

    case actionTypes.productLibrary.updateFlowVersion: {
      const { flowUuid, versionData } = action.payload;

      return {
        ...state,
        categories: state.categories.map(category => {
          // Check if this category contains the target flow
          const hasTargetFlow = category.flows.some(f => f.uuid === flowUuid);

          if (!hasTargetFlow) {
            return category; // Skip categories that don't contain the flow
          }

          return {
            ...category,
            flows: category.flows.map(
              flow => flow.uuid === flowUuid
                ? {
                  ...flow,
                  assets: versionData.assets,
                  screen_count: versionData.screen_count,
                  current_version: versionData.version_number,
                }
                : flow
            ),
          };
        }),
      };
    }

    default:
      return state;
  }
};

export default productLibraryReducer;
